export const ExtraData = [
    {
        id:1,
        title: "Classical Dance",
        image: "/images/Students/ExtraCurricular/Bharatham.webp",
    },
    {
        id:2,
        title: "Bands",
        image: "/images/Students/ExtraCurricular/Bands.webp",
    },
    {
        id:3,
        title: "Karate",
        image: "/images/Students/ExtraCurricular/Karate.webp",
    },
    {
        id:4,
        title: "Skating",
        image: "/images/Students/ExtraCurricular/Skating.webp",
    },
    {
        id:5,
        title: "Boxing",
        image: "/images/Students/ExtraCurricular/Boxing.webp",
    },
    {
        id:6,
        title: "Silambam",
        image: "/images/Students/ExtraCurricular/Silambam.webp",
    },
];